<template>
  <div>
    <div class="overlay">
      <div v-if="$route.name === 'Home'">
        <div class="overlay-body">
          <p class="tutorial-text">まずはじめに<br />基本データ<br />健康度チェック<br />をしましょう</p>
        </div>
        <img class="tap" src="@/assets/アセット 8@2x.png" />
        <router-link to="/other">
          <div class="other">
            <img src="@/assets/footer/アセット 19@2x.png" />
          </div>
        </router-link>
      </div>
      <div v-else>
        <div>
          <img class="other-tap" src="@/assets/アセット 8@2x.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tutorial",
};
</script>

<style scoped>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 3;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  /*画面の中央に要素を表示させる設定*/
  display: flex;
  align-items: center;
  justify-content: center;
}
p.tutorial-text {
  color: white;
  font-size: 2rem;
}
.tap {
  position: absolute;
  bottom: 15%;
  right: 5%;
  width: 25%;
  animation: move-y 0.5s infinite alternate ease-in-out;
  display: inline-block;
}
.other-tap {
  position: absolute;
  z-index: 2;
  width: 30%;
  top: 5%;
  left: 35%;
  animation: move-y 0.5s infinite alternate ease-in-out;
  display: inline-block;
}
@keyframes move-y {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(10px);
  }
}
.other {
  position: absolute;
  bottom: 0;
  right: 2%;
  background: white;
  width: 25%;
  padding: 15px 10px 10px 10px;
  border-radius: 50%;
  height: 10%;
}
.other img {
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue